import { useState, useEffect } from 'react';
import styles, { global } from './styles';
import Slider from "react-slick";

const Carousel = ({ items, type }) => {
  const slidesShowNumber = 1;
  const [currentSlideCount, setCurrentSlideCount] = useState(1);

  const onBeforeChange = () => {
    if (currentSlideCount === Math.ceil(items.filter(item => item.type === type).length)) {
      setCurrentSlideCount(1)
    } else {
      setCurrentSlideCount(currentSlideCount + 1)
    }
  };
  const settings = {
    beforeChange: onBeforeChange,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: slidesShowNumber,
    slidesToScroll: slidesShowNumber,
    variableWidth: true,
    nextArrow: (
      <CustomCarouselArrow
        src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/arrow-right-next.png?v=1714031836"
        alt="arrow-right"
      />
    ),
    prevArrow: (
      <CustomCarouselArrow
        src="https://cdn.shopify.com/s/files/1/0637/0407/2436/files/arrow-left-prev.png?v=1714031752"
        alt="arrow-left"
        rightPosition={40}
      />
    )
  };

  return (
    <>
      <div className='card-section'>
        <div>
          <p className='title'>{type}</p>
        </div>
          <input
            className='range-gallery-desktop'
            type="range"
            min="0"
            max={Math.ceil(items.filter(item => item.type === type).length)}
            value={currentSlideCount}
          />
          
          <Slider {...settings}>
          {items.map((item, i) => {
            if (item.type === type) {
              return (
                <div key={i} className='card-container'>
                  <div className='card-box'>
                    <img className="card-img" src={item.image?.url}/>
                    <p className='card-title'>{item.title1}</p>
                  </div>
                </div>
              )
            }
            })
          }
        </Slider>

        <input
            className='range-gallery-mobile'
            type="range"
            min="0"
            max={Math.ceil(items.filter(item => item.type === type).length)}
            value={currentSlideCount}
          />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

function CustomCarouselArrow({ src, alt, onClick, rightPosition }) {
  return (
    <>
      <button className="button" onClick={onClick}>
        <img src={src} alt={alt} />
      </button>
      <style jsx>{`
        .button {
          position: absolute;
          top: -65px;
          right: ${rightPosition || 0}px;
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          line-height: 0;
        }
        @media (width<=991px) {
          .button {
            top: -70px;
          }
        }
      `}</style>
    </>
  );
}

export default Carousel;;